import { ArrowIcon } from "assets/icons";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Icon } from "ui";

import { ReturnModalAtomProps } from "../../ReturnModal.types";
import { ReturnModalBlock } from "./ReturnModalBlock";

import styles from "../../ReturnModal.module.scss";

export const ReturnModalInfoRow = ({ returnDetails }: ReturnModalAtomProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.returnModal_info}>
      <ReturnModalBlock label={t("Order Number")}>
        <div>{returnDetails.id}</div>

        <Link
          to={{ pathname: "/orders", search: `orderId=${returnDetails.id}` }}
          target="_blank"
          className={styles.returnModal_info_showOrderLink}
        >
          <span>{t("Show order")}</span>
          <Icon
            as={ArrowIcon}
            boxSize={18}
            className={styles.returnModal_info_linkArrow}
            color="#f4318f"
          />
        </Link>
      </ReturnModalBlock>

      <ReturnModalBlock label={t("Delivery Address")}>
        <div className={styles.returnModal_info_delivery}>
          <div className={styles.returnModal_info_delivery_name}>
            {returnDetails?.deliveryAddress.fullName}
          </div>
          <p>{returnDetails?.deliveryAddress.phoneNumber}</p>
          <p>
            {returnDetails?.deliveryAddress.address},{" "}
            {returnDetails?.deliveryAddress.deliveryZone.neighborhood},{" "}
            {returnDetails?.deliveryAddress.deliveryZone.city},{" "}
            {returnDetails?.deliveryAddress.deliveryZone.country}
          </p>
        </div>
      </ReturnModalBlock>

      <ReturnModalBlock label={t("Refund Method")}>
        <div>{returnDetails.returnMobileMoneyNumber}</div>
      </ReturnModalBlock>

      <ReturnModalBlock label={t("Order date")}>
        <pre>
          {`${moment(returnDetails.createdAt).format("DD/MM/YYYY")}`}
          {"\n"}
          {`${moment(returnDetails.createdAt).format("HH:mm")}`}
        </pre>
      </ReturnModalBlock>

      <ReturnModalBlock label={t("Request date")}>
        <pre>
          {`${moment(returnDetails.returnRequestedAt).format("DD/MM/YYYY")}`}
          {"\n"}
          {`${moment(returnDetails.returnRequestedAt).format("HH:mm")}`}
        </pre>
      </ReturnModalBlock>
    </div>
  );
};
